import {
    BASE_URL
} from '../../utils/url-builder'
import BaseService from '../services/base.service'

class ClassFeedService extends BaseService {
    constructor() {
        super(BASE_URL);
        this.route = "feed/"
    }

    fecthAllPosts = (classId) => new Promise(async (resolve, reject) => {
        try {
            let allPosts = await this.makeGetRequest(this.route + 'post/fetch', { classId});
            return resolve(allPosts)
        } catch (error) {
            reject(error)
        }
    })

    fecthAllPostsWithFilter = (classId,startDate,endDate) => new Promise(async (resolve, reject) => {
        try {
            let allPosts = await this.makeGetRequest(this.route + 'post/fetch', {classId,startDate,endDate});
            return resolve(allPosts)
        } catch (error) {
            reject(error)
        }
    })

    create = (classId,text,creatorId) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "post/create", { classId,text,creatorId });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    update = (postId, text) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "post/update", { id:postId, text: text });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    read = (postId) => new Promise(async (resolve, reject) => {
        try {
            let settings = await this.makeGetRequest(this.route + 'post/read', { id:postId });
            return resolve(settings)
        } catch (error) {
            reject(error)
        }
    })

    delete = (postId) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "post/delete", { id:postId });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    createComment = (postId,text,creatorId,classId) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "comment/create", { postId,text,creatorId,classId });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    updateComment = (commentId, text) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "comment/update", { id:commentId, text: text });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    readComment = (commentId) => new Promise(async (resolve, reject) => {
        try {
            let settings = await this.makeGetRequest(this.route + 'comment/read', { id:commentId });
            return resolve(settings)
        } catch (error) {
            reject(error)
        }
    })

    deleteComment = (commentId) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "comment/delete", { id:commentId });
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

}

const classFeedService = new ClassFeedService()

export default classFeedService